import { Component, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from './modal.component';
import * as moment from 'moment';

@Component({
    selector: 'delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent {
    @ViewChild('modal') modal: ModalComponent;
    @Output() closed = new EventEmitter();
    @Input() removingObjectName = 'объект';

    isLoading: boolean;

    open() {
        this.modal.open();
    }

    remove() {
        this.closed.emit({ needToDelete: true });
        this.modal.close();
    }

    cancel() {
        this.modal.close();
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/delete-confirmation.component.ts